'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SecurityVisitor = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _QueryNodeVisitor2 = require('../engine/QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

var _SecurityClause = require('./SecurityClause');

var _SecurityClause2 = _interopRequireDefault(_SecurityClause);

var _InstitutionSecurityClause = require('./InstitutionSecurityClause');

var _InstitutionSecurityClause2 = _interopRequireDefault(_InstitutionSecurityClause);

var _DocumentTypeSecurityClause = require('./DocumentTypeSecurityClause');

var _DocumentTypeSecurityClause2 = _interopRequireDefault(_DocumentTypeSecurityClause);

var _DapsSecurityClause = require('./DapsSecurityClause');

var _DapsSecurityClause2 = _interopRequireDefault(_DapsSecurityClause);

var _lodash = require('lodash');

var _jsonHelper = require('../jsonHelper');

var _jsonHelper2 = _interopRequireDefault(_jsonHelper);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require('debug')('@complion:query:security:SecurityVisitor');

var SecurityVisitor = exports.SecurityVisitor = function (_QueryNodeVisitor) {
    (0, _inherits3.default)(SecurityVisitor, _QueryNodeVisitor);

    function SecurityVisitor(queryNode) {
        (0, _classCallCheck3.default)(this, SecurityVisitor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SecurityVisitor.__proto__ || (0, _getPrototypeOf2.default)(SecurityVisitor)).call(this));

        _this.queryNode = queryNode;
        _this.lastSecurityConditions;
        return _this;
    }

    (0, _createClass3.default)(SecurityVisitor, [{
        key: 'visitAllFilesQuery',
        value: function visitAllFilesQuery(context) {
            context.allFilesQuery = context.currentNode;
            context.skipData = true;
            var ids = context.appContext.documentIds;
            this.queryNode.documentIds = ids;
        }
    }, {
        key: 'visitBinderQuery',
        value: function visitBinderQuery(context) {
            var binderNode = (0, _lodash.get)(this.queryNode, context.path, this.queryNode);
            context.binderDaps = binderNode.binderDaps || context.appContext.binderDaps || [];
            context.userDaps = binderNode.userDaps || context.appContext.userDaps || [];
            context.skipData = true;
            context.skipChildren = true;
            if (!context.appContext.isSecurityClauseNeeded || context.appContext.isSecurityClauseNeeded[binderNode.nodeId]) {
                this.applySecurityToCurrentNode(context);
            } else {
                this.lastSecurityConditions = binderNode;
            }
        }
    }, {
        key: 'visitUnfiledDocumentsQuery',
        value: function visitUnfiledDocumentsQuery(context) {
            context.ignoreDocumentTypeIds = true;
            context.ignoreDaps = true;
            this.applySecurityToCurrentNode(context);
        }
    }, {
        key: 'applySecurityToCurrentNode',
        value: function applySecurityToCurrentNode(context) {
            var ignoreDaps = context.ignoreDaps,
                ignoreDocumentTypeIds = context.ignoreDocumentTypeIds,
                binderDaps = context.binderDaps,
                userDaps = context.userDaps,
                appContext = context.appContext;
            var institutionId = appContext.institutionId,
                documentTypeIds = appContext.documentTypeIds;

            var securityConditions = new _SecurityClause2.default();
            var conditionsNode = (0, _lodash.get)(this.queryNode, context.path, this.queryNode);

            var institutionSecurity = new _InstitutionSecurityClause2.default({ data: { institutionId: institutionId } });
            securityConditions.addChild(institutionSecurity);

            if (!ignoreDocumentTypeIds) {
                if (!documentTypeIds) {
                    //err on the side of caution and show no documents.
                    documentTypeIds = [];
                }
                var documentTypeSecurity = new _DocumentTypeSecurityClause2.default({ data: { documentTypeIds: documentTypeIds } });
                securityConditions.addChild(documentTypeSecurity);
            }

            if (!ignoreDaps) {
                var allDaps = [].concat((0, _toConsumableArray3.default)(userDaps), (0, _toConsumableArray3.default)(binderDaps));
                if (allDaps.length > 0) {
                    debug('applying ' + allDaps.length + ' daps');
                    var dapsConditions = allDaps.map(function (daps) {
                        var deserializedJson = _jsonHelper2.default.parse(daps.query);
                        return _QueryNodeRegistry2.default.reconstituteDeserializedJson(deserializedJson);
                    });
                    var dapsSecurity = new _DapsSecurityClause2.default();
                    dapsSecurity.addChildren(dapsConditions);
                    securityConditions.addChild(dapsSecurity);
                }
            }

            if (context.allFilesQuery) {
                var index = context.path[context.path.length - 1];
                var binderQueryNode = this.queryNode.children[index];
                this.queryNode.replaceChildAt(index, securityConditions);
                securityConditions.addChild(binderQueryNode);
            } else {
                securityConditions.addChild(conditionsNode);
            }

            this.lastSecurityConditions = securityConditions;
        }
    }]);
    return SecurityVisitor;
}(_QueryNodeVisitor3.default);

exports.default = SecurityVisitor;